import { render, staticRenderFns } from "./Mentions.vue?vue&type=template&id=d5cd4eda&scoped=true"
import script from "./Mentions.vue?vue&type=script&lang=js"
export * from "./Mentions.vue?vue&type=script&lang=js"
import style0 from "./Mentions.vue?vue&type=style&index=0&id=d5cd4eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cd4eda",
  null
  
)

export default component.exports